import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Paper, Grid } from "@mui/material";
import ProfileTab from "../../components/Settings/ProfileTab/ProfileTab";
import AppSettings from "../../components/Settings/AppSettingsTab/AppSettings";
import ChangePassword from "../../components/Settings/ChangePasswordTab/ChangePassword";
import ContactUs from "../../components/Settings/ContactUsTab/ContactUs";
import PrivacyPolicyNotice from "../../components/Settings/PrivacyTab/Privacy";
import Terms from "../../components/Settings/TermsTab/Terms";
import ConnectStripe from "../../components/Settings/PaymentIntegration/ConnectStripe";
import { useLocation } from "react-router-dom";

function SettingsMain() {
  const [value, setValue] = useState(0);
  const location = useLocation();

  const { from } = location.state || {};
  const state = JSON.parse(sessionStorage.getItem("navigationState"));
  useEffect(() => {
    if ((from === "login" || state?.from === "login") && state) {
      setValue(4);
    } 
      sessionStorage.removeItem("navigationState");
    
  }, [from, state]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid p={1.5}>
      <Paper
        elevation={1}
        sx={{
          minHeight: "80vh",
          padding: 0.5,
          overflowX: "hidden",
          maxWidth: "100%",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ maxWidth: "100%" }}
        >
          <Tab label="Profile" />
          <Tab label="App Settings" />
          <Tab label="Change Password" />
          <Tab label="Contact Us" />
         {/*  <Tab label="Privacy Policy" />
          <Tab label="Terms and Condition" /> */}
          <Tab label="Payment Integration" />
        </Tabs>
        {value === 0 && <ProfileTab />}
        {value === 1 && (
          <Box sx={{ my: 3, p: 2 }}>
            <AppSettings />
          </Box>
        )}
        {value === 2 && (
          <Box sx={{ mt: 3, p: 2 }}>
            <ChangePassword />
          </Box>
        )}
        {value === 3 && (
          <Box sx={{ mt: 2, p: 2 }}>
            <ContactUs />
          </Box>
        )}
        {/* {value === 4 && (
          <Box sx={{ mt: 0, p: 2  }}>
            <PrivacyPolicyNotice />
          </Box>
        )}
        {value === 5 && (
          <Box sx={{ mt: 3, p: 2 }}>
            <Terms />
          </Box>
        )} */}
        {value === 4 && (
          <Box sx={{ mt: 2,p: 2 }}>
            <ConnectStripe />
          </Box>
        )}
      </Paper>
      {/* <ScanButton/> */}
    </Grid>
  );
}

export default SettingsMain;
